module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-31119fa0.png";